module.exports = __webpack_public_path__ + "img/img_title3.2d5412f8.png";